<template>
  <VLoader v-if="loading" />
  <section v-else class="shared-section products">
    <div>
      <header class="shared-section-header">
        <h2 class="shared-section-header-heading">{{ $t('products.heading') }}</h2>
      </header>
      <ul class="mb-8 grid grid-cols-1 gap-4 sm:grid-cols-3 lg:grid-cols-4">
        <li v-for="(product, index) in removedDuplicateProducts" :key="`${product.id}-${index}`">
          <Product :product="product" />
        </li>
      </ul>
    </div>
  </section>
</template>

<script>
import { mapState } from 'vuex';

import { safeNullDataset, removeDuplicates, isChroma } from '@/utils';

import Product from '@/components/customer/Product';
import VLoader from '@/components/base/VLoader';

export default {
  name: 'Products',
  components: { Product, VLoader },
  data() {
    return {
      loading: false,
    };
  },
  computed: mapState({
    products: state => safeNullDataset(state)(['customer', 'products']),
    filteredMultiChromaProducts() {
      return this.products.reduce((acc, product) => {
        return acc.some(
          p => isChroma(p.display_name) && !p.display_name.trim().toLowerCase().includes('legacy'),
        ) &&
          isChroma(product.display_name) &&
          !product.display_name.trim().toLowerCase().includes('legacy')
          ? acc
          : acc.concat(product);
      }, []);
    },
    removedDuplicateProducts() {
      return removeDuplicates(this.filteredMultiChromaProducts, 'id');
    },
  }),
  async mounted() {
    if (!this.products.length) {
      this.loading = true;
      await this.$store.dispatch('customer/getProducts');
      this.loading = false;
    }
  },
};

/**
 *  Products Name:
 *  1 - EM-1010
 *  2 - 1501-TC
 *  3 - SWD-1501
 *  4 - MT-1501
 *  5 - CHT2 Series:
 *    A - CHT2-1504-10.4S
 *    B - CHT2-1504-10.4W
 *    C - CHT2-1506-10.4S
 *    D - CHT2-1506-10.4W
 *    E - CHT2-1508-10.4S
 *    F - CHT2-1508-10.4S-W
 *    G - CHT2-1512-10.4S
 *  6 - CHROMA
 */
</script>
